<template>
  <div>
    <div id="container"></div>
  </div>
</template>

<script>
import AMap from "AMap";

export default {
  props: {
    lngLat: {
      type: Object,
      default() {
        let tmpLngLat = {
          lng: 118.74351, // 纬度
          lat: 32.02087  // 经度
        }
        return tmpLngLat;
      }
    },
    markers: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      map: null, // 地图对象
      isShowUnbuild: false,
      mapInfo1: "",
      mapInfo2: "",
      cluster:null
    };
  },
  mounted() {
    this.mapInit();
  },
  methods: {
    /**
     * 根据传入的值渲染地图及传出经纬度和地名
     * @param lng 经度
     * @param lat 纬度
     * @param zoom 地图缩放级别
     */
    mapInit() {
      let _this = this;
      // 在页面渲染完成后进行地图的实例化
      this.$nextTick(() => {
        _this.map = new AMap.Map(document.getElementById("container"), {
          // 地图的中心地理坐标。
          center: new AMap.LngLat(this.lngLat.lng, this.lngLat.lat),
          zoom: 12,
          mapStyle:'amap://styles/add9c9339c2943abbbfd3a691b8ffdf6'
        });
        this.addCluster();
      });
    },
    refreshMap() {
      this.map.clearMap(); // 清除地图覆盖物
      this.mapInit();
    },
    addCluster(tag) {
      let that = this;
      this.map.plugin(["AMap.MarkerClusterer"],function() {
        var _renderClusterMarker = function (context) {
            var factor = Math.pow(context.count / count, 1 / 18);
            var div = document.createElement('div');
            var Hue = 180 - factor * 180;
            var bgColor = 'hsla(' + Hue + ',100%,50%,0.7)';
            var fontColor = 'hsla(' + Hue + ',100%,20%,1)';
            var borderColor = 'hsla(' + Hue + ',100%,40%,1)';
            var shadowColor = 'hsla(' + Hue + ',100%,50%,1)';
            div.style.backgroundColor = bgColor;
            var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
            div.style.width = div.style.height = size + 'px';
            div.style.border = 'solid 1px ' + borderColor;
            div.style.borderRadius = size / 2 + 'px';
            div.style.boxShadow = '0 0 1px ' + shadowColor;
            div.innerHTML = context.count;
            div.style.lineHeight = size + 'px';
            div.style.color = fontColor;
            div.style.fontSize = '14px';
            div.style.textAlign = 'center';
            context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
            context.marker.setContent(div)
        };
        if (that.cluster ) {
            that.cluster.setMap(null);
        }
        if (tag == 2) {//完全自定义
            that.cluster  = new AMap.MarkerClusterer(that.map, that.markers, {
                gridSize: 80,
                renderClusterMarker: _renderClusterMarker
            });
        } else if (tag == 1) {//自定义图标
            var sts = [{
                url: "https://a.amap.com/jsapi_demos/static/images/blue.png",
                size: new AMap.Size(32, 32),
                offset: new AMap.Pixel(-16, -16)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/green.png",
                size: new AMap.Size(32, 32),
                offset: new AMap.Pixel(-16, -16)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/orange.png",
                size: new AMap.Size(36, 36),
                offset: new AMap.Pixel(-18, -18)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/red.png",
                size: new AMap.Size(48, 48),
                offset: new AMap.Pixel(-24, -24)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/darkRed.png",
                size: new AMap.Size(48, 48),
                offset: new AMap.Pixel(-24, -24)
            }];
            that.cluster  = new AMap.MarkerClusterer(that.map, that.markers, {
                styles: sts,
                gridSize: 80
            });
        } else {//默认样式
            that.cluster  = new AMap.MarkerClusterer(that.map, that.markers, {gridSize: 80,minClusterSize:2});
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
#container {
  width: 100%;
  height: 100%;
  border: 1px solid #000;
}
.info {
  position: relative;
  top: -33em;
  background: #ffffff;
  width: fit-content;
  height: 3em;
  margin-left: 1.5em;
  margin-top: 1.5em;
  line-height: 3em;
  display: flex;
  flex-direction: row;
  padding-left: 0.8em;
  border: 1px solid #d6d0d0;
  border-radius: 0.3em;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
}
.imgDiv {
  text-align: center;
  line-height: 3em;
  height: 3em;
  padding-top: 0.5em;
  margin-right: 0.5em;
}
.textSty {
  margin-right: 1em;
}
.imgDiv2 {
  line-height: 3em;
  height: 3em;
  padding-top: 0.5em;
  margin-right: 0.5em;
}
.textSty2 {
  margin-right: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/maintenanceMonitoring/MMap.vue